<template>
    <div class="mobile-page clearfix">
        <div class="seckill-box" :style="{background: configData.bgColor.color[0].item,marginTop:configData.mbConfig.val+'px'}">
            <div class="hd">
                <div class="left">
<!--                    <img :src="imgUrl" alt="" />-->
                    <p>限时秒杀</p>
                    <div class="time">
                        <span :style="{ background: configData.countDownColor.color[0].item, color: configData.themeColor.color[0].item }">00</span>
                        <em>:</em>
                        <span :style="{ background: configData.countDownColor.color[0].item, color: configData.themeColor.color[0].item }">00</span>
                        <em>:</em>
                        <span :style="{ background: configData.countDownColor.color[0].item, color: configData.themeColor.color[0].item }">00</span>
                    </div>
                </div>
                <div class="right">
                    更多
                </div>
            </div>
            <div class="list-wrapper">
                <div class="list-item"
                     v-for="(item, index) in configData.list"
                     :index="index + ''"
                     :style="{ marginRight:  '10px' }">
                    <div class="img-box">
                        <img :src="item.img" alt="" v-if="item.img" />
                        <div class="empty-box"><span class="iconfont icontupian"></span></div>
                    </div>
                    <div class="title line1">{{ item.name }}</div>
                    <div class="price">
                        <span class="label" :style="{ background: configData.themeColor.color[0].item }">抢</span>
                        <span class="num-label" :style="{ color: configData.themeColor.color[0].item }">￥</span>
                        <span class="num" :style="{ color: configData.themeColor.color[0].item}">{{item.price}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "seckill",
        cname: '秒杀',
        sort: 300,
        type: 1, // 0 基础组件 1 营销组件 2工具组件
        icon: 'iconmiaosha1',
        props: {
            configData: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                defaultConfig: {
                    name: "seckill",
                    cname: '秒杀',
                    tabs: [
                        {
                            title: '内容设置'
                        },
                        {
                            title: '样式设置'
                        }
                    ],
                    styles: {
                        numConfig: {
                            tab: 0,
                            name: 'inputnumber',
                            min: 1,
                            val: 3
                        },
                        themeColor: {
                            tab: 1,
                            title: '主题风格',
                            name: 'color',
                            default: [
                                {
                                    item: '#E93323'
                                }
                            ],
                            color: [
                                {
                                    item: '#E93323'
                                }
                            ]
                        },
                        countDownColor: {
                            title: '倒计时背景色',
                            name: 'color',
                            default: [
                                {
                                    item: 'rgba(252,60,62,0.09)'
                                }
                            ],
                            color: [
                                {
                                    item: 'rgba(252,60,62,0.09)'
                                }
                            ]
                        },
                        bgColor: {
                            tab: 1,
                            title: '背景颜色',
                            name: 'color',
                            default: [{
                                item: '#fff'
                            }],
                            color: [
                                {
                                    item: '#fff'
                                }
                            ]
                        },
                        // 左右间距
                        lrConfig: {
                            tab: 1,
                            name: 'slider',
                            title: "左右边距",
                            val: 10,
                            min: 0,
                        },
                        // 页面间距
                        mbConfig: {
                            tab: 1,
                            name: 'slider',
                            title: "页面间距",
                            val: 0,
                            min: 0,
                        },
                        list: [
                            {
                                img: '',
                                name: '小米家用电饭煲小米家用电饭煲',
                                price: '234',
                                discount: '1.2'
                            },
                            {
                                img: '',
                                name: '小米家用电饭煲小米家用电饭煲',
                                price: '234',
                                discount: '1.2'
                            },
                            {
                                img: '',
                                name: '小米家用电饭煲小米家用电饭煲',
                                price: '234',
                                discount: '1.2'
                            }
                        ],
                    }
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .seckillOn{
        border-radius: 0!important
    }
    .pageOn{
        border-radius: 10px!important
    }

    .seckill-box {
        padding: 15px 10px;
        background: #fff;
        border-radius: 10px;

        .hd {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .left {
                display: flex;
                align-items: center;

                img {
                    width: 18px;
                    height: 18px;
                    margin-right: 5px;
                    border-radius: 50%;
                }

                p {
                    font-size: 16px;
                    color: #282828;
                    font-weight: 600;;
                }

                .time {
                    display: flex;
                    align-items: center;
                    margin-left: 5px;
                    color: #FF4444;

                    span {
                        width: 20px;
                        height: 16px;
                        font-size: 12px;
                        text-align: center;
                        line-height: 16px;
                    }

                    em {
                        font-size: 12px;
                        margin: 0 3px;
                        font-style: initial;
                        font-weight: bold;
                    }
                }
            }
        }

        .list-wrapper {
            display: flex;
            margin-top: 8px;
            overflow: hidden;

            .list-item {
                flex-shrink: 0;
                width: 110px;
                background-color: #fff;

                .img-box {
                    position: relative;
                    width: 100%;
                    height: 110px;

                    img, .box {
                        width: 100%;
                        height: 100%;
                        border-radius: 8px;
                    }

                    .box {
                        background: #D8D8D8;
                    }

                    .discount {
                        position: absolute;
                        left: 8px;
                        bottom:8px;
                        height: 18px;
                        padding: 0 3px;
                        line-height: 18px;
                        background: rgba(255, 255, 255, 1);
                        border-radius: 2px;
                        border: 1px solid transparent;
                        font-size: 12px;
                    }
                }

                .title {
                    margin-top: 5px;
                    font-size: 13px;
                    color: #282828;
                    padding: 0 3px;
                    line-height: 1.5;
                }

                .price {
                    display: flex;
                    align-items: center;
                    padding: 0 3px;
                    line-height: 1.5;
                    .label {
                        font-size: 9px;
                        width: 16px;
                        height: 16px;
                        color: #fff;
                        text-align: center;
                        line-height: 16px;
                    }

                    .num-label {
                        color: #FF4444;
                        font-size: 12px;
                        font-weight: 600;
                        margin: 1px 2px 0;
                    }

                    .num {
                        color: #FF4444;
                        font-size: 16px;
                        font-weight: 600;
                    }
                }
            }
        }
    }
</style>
